import React, { useRef, useState } from "react";
import { CountrySelect, CountryData, countriesData } from "./countrySelect";
import { parsePhoneNumberFromString, AsYouType, CountryCode } from "libphonenumber-js";

type PhoneNumber = {
	dialCode: string;
	number: string;
	country: string;
};

export function formatPhoneNumber(value: string): PhoneNumber {
	if (value) {
		const phoneNumber = parsePhoneNumberFromString(value);
		if (phoneNumber) {
			return {
				dialCode: phoneNumber.countryCallingCode.toString(),
				number: phoneNumber.nationalNumber.toString(),
				country: phoneNumber.country,
			};
		}
	}
	return { dialCode: null, number: "", country: null };
}

export function parsePhoneNumber({ dialCode, number, country }: PhoneNumber, name: string): string {
	return `+${dialCode ? dialCode : ""}${number}`;
}

function formatDropdownOption(country: CountryData): string {
	return `${country.name} (+${country.dialCode})`;
}

function getDialCode(country: string): string {
	if (!country) {
		return undefined;
	}
	const countryData = countriesData[country.toLowerCase()] as CountryData;
	return countryData.dialCode;
}

export default function PhoneNumberInput({
	input: { onChange, value, name },
	country,
	meta,
	...rest
}: {
	input: { onChange; value: PhoneNumber; name };
	country: string;
	meta: any;
	rest?: any;
}) {
	const ref = useRef<HTMLInputElement>();

	if (!value.dialCode) {
		let countryData = null;
		if (country) {
			countryData = countriesData[country.toLowerCase()] as CountryData;
		}

		if (!countryData) {
			countryData = countriesData["ch"];
		}

		value.dialCode = countryData.dialCode;
	}
	const [selectedCountry, setCountry] = useState(value.country || country);
	const [numberValue, setValue] = useState<PhoneNumber>(value);

	const handleChange = e => {
		const number = e.target.value;
		const newValue = { ...numberValue, number };
		setValue(newValue);
		onChange(newValue);
	};

	const onCountryChange = (iso2: string) => {
		const dialCode = getDialCode(iso2);

		const newValue = { ...numberValue, dialCode };
		setValue(newValue);
		setCountry(iso2);
		onChange(newValue);
	};

	return (
		<div className="horizontal">
			<CountrySelect value={selectedCountry} onChange={onCountryChange} formatFunction={formatDropdownOption} />
			<input
				name={name}
				type="text"
				value={new AsYouType(selectedCountry.toUpperCase() as CountryCode).input(numberValue.number)}
				onChange={handleChange}
				//@ts-ignore
				placeholder={rest.placeholder}
				ref={ref}
			/>
		</div>
	);
}
